/**
 * Karrier Handler service module
 * @author Erik Banhalmi 2017.06.27.
 */
import angular from 'angular';

import { CareerHandlerService } from './career-handler.service';

const MODULE_NAME = 'careerHandler';

export default angular.module(MODULE_NAME, []).service('CareerHandlerService', CareerHandlerService).name;
